// removed by extract-text-webpack-plugin
module.exports = {"button":"_3J0jI","wrapper":"_1FI9U","share":"_2T_67","downloadLabel":"_2VZUx","buttonContainer":"_1ikoY","code":"_1l4d-","orchestraCode":"_16Rwh","info":"_1p5Yl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareButton.css
// module id = 808
// module chunks = 0